export default __webpack_public_path__ + "static/media/add-announcement-enabled.e8031fa2.svg";